import {addFilter} from '@wordpress/hooks';
import {getSetting} from '@woocommerce/settings';
import {select} from '@wordpress/data';
import {CART_STORE_KEY} from '@woocommerce/block-data';

/**
 * Gateways that don't support 'subscriptions' (@see WooCommerceSubscriptionsTrait) still receive
 * mode: 'setup'/'subscription' from PHP (AbstractStripeLocalPayment::get_cart_extension_data()),
 * since that decision is made without knowing which specific gateway will render. Manual renewals
 * don't require automatic reuse though - WooCommerce Subscriptions just emails the customer to pay
 * renewals manually - so those gateways fall back here to mode: 'payment', rather than the blocks
 * payment method components needing to know anything about subscriptions.
 */
function isIncompatibleSubscriptionGateway(gatewayId, mode) {
    if (!gatewayId || (mode !== 'setup' && mode !== 'subscription')) {
        return false;
    }
    return !getSetting(`${gatewayId}_data`)?.features?.includes('subscriptions');
}

/**
 * mode: 'payment' requires a positive amount. When the live cart total is 0 (e.g. a free trial),
 * fall back to the recurring cart total - already computed server-side and exposed on the Store
 * API cart response by PaymentIntent::add_recurring_total_to_cart_data() (@wc_stripe_cart_data) -
 * so the element can still mount. Nothing is actually charged today either way
 * (@see WC_Payment_Gateway_Stripe::process_zero_total_order()).
 */
function getFallbackAmountCents() {
    const cart = select(CART_STORE_KEY)?.getCartData();

    return cart?.extensions?.wc_stripe?.cart?.recurringTotalCents || 0;
}

addFilter('wc_stripe_blocks_element_options', 'wc-stripe/subscriptions', (options, gatewayId) => {
    if (isIncompatibleSubscriptionGateway(gatewayId, options.mode)) {
        options.mode = 'payment';
        options.amount = options.amount || getFallbackAmountCents();
    }
    return options;
});